// extracted by mini-css-extract-plugin
export default {"heading":"index_heading__16cFs container_container__1mYuP"};